// Copyright (c) Meta Platforms, Inc. and affiliates.

'use client';

/**
 * @file NavMenuItem.tsx
 * @input NavHeadingMenuItem
 * @output Exports deprecated NavMenuItem alias
 * @position Compatibility re-export; prefer NavHeadingMenuItem
 */
import { NavHeadingMenuItem } from "./NavHeadingMenuItem.js";

/** @deprecated Use NavHeadingMenuItem instead. */

/** @deprecated Use NavHeadingMenuItem instead. */
export const NavMenuItem = NavHeadingMenuItem;